import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { routes } from "src/constants/routes";
import { ArtefactFilterOptions } from "src/models/manage-artifact-filter.model";
import { HeaderFilterComponent } from "src/pages/header-filter/header-filter.component";
import { ManageArtefactFilterDialogDialogComponent } from "src/pages/manage-artefact-filter-dialog/manage-artefact-filter-dialog.component";
import { Breadcrumb } from "src/pages/shared/breadcrumbs/breadcrumbs.component";
import { SharedAppModule } from "src/pages/shared/shared.module";
import { UtilityService } from "src/services/utility.service";
import { ORGANIZATION_MEMBER_HEADERS } from "../ranking/constants";
import { finalize } from "rxjs/operators";
import { ApiService } from "src/services/api.service";

@Component({
  selector: "app-org-member-list",
  templateUrl: "./org-member-list.component.html",
  styleUrls: ["./org-member-list.component.scss"],
  standalone: true,
  imports: [SharedAppModule, CommonModule, HeaderFilterComponent],
})
export class OrgMemberListComponent {
  readonly routes = routes;
  isFilterApplied = false;
  filters: any = {};
  appliedFilters?: ArtefactFilterOptions;
  search = "";
  filterConfig = {
    artifactType: true,
  };
  orgDetail: any;
  total = 0;
  isLoading: boolean = false;
  tableData: any[] = [];
  breadcrumbList: Breadcrumb[] = [
    {
      label: "Leaderboard",
      route: "/admin/dashboard",
      queryParams: { tab: 2, childTab: 3 },
    },
    {
      label: "Organization",
      route: "/admin/dashboard/org-members",
      queryParams: { tab: 2, childTab: 3 },
    },
  ];
  orgId: any;
  page = 0;
  size = 10;
  tableHeaders = ORGANIZATION_MEMBER_HEADERS;

  constructor(
    private matDialog: MatDialog,
    private utilityService: UtilityService,
    private router: Router,
    private apiService: ApiService
  ) {}

  ngOnInit() {
    const navigation = history.state;

    if (!navigation.orgDetail) {
      this.router.navigate([routes.admin, routes.dashboard], {
        queryParams: { tab: 2, childTab: 3 },
      });
      return;
    }
    this.orgDetail = navigation?.orgDetail;
    this.orgId = navigation?.orgDetail.id;
    this.getContributorList();
  }

  searchByText(search: string) {
    this.search = search;
    this.page = 0;
    this.getContributorList();
  }

  readonly headerFilterData: any = {
    placeholder: "Search here",
  };

  onPageChange(event: any) {
    this.page = event.pageIndex;
    this.size = event.pageSize;
    this.getContributorList();
  }

  openFilters() {
    this.matDialog
      .open(ManageArtefactFilterDialogDialogComponent, {
        data: {
          filters: this.appliedFilters,
          config: this.filterConfig,
        },
      })
      .afterClosed()
      .subscribe((filters?: ArtefactFilterOptions) => {
        if (!filters) return;

        this.appliedFilters = filters;
        const updatedFilters: any = {
          organizationType: JSON.stringify(
            filters?.organizationType?.map((v) => v.value)
          ),
          sourceOrganization: JSON.stringify(
            filters?.sourceOrganization?.map((v) => v.value)
          ),
          userType: JSON.stringify(filters?.userType?.map((v) => v.value)),
          visibility: JSON.stringify(filters?.visibility?.map((v) => v.value)),
          sector: JSON.stringify(filters?.sector?.map((v) => v.value)),
          artifactType: JSON.stringify(
            filters?.artifactType?.map((v) => v.value)
          ),
        };

        this.filters = this.utilityService.removeBlankFields(updatedFilters);
        this.isFilterApplied = Object.values(this.appliedFilters).some(
          (value) =>
            (Array.isArray(value) && value.length > 0) ||
            (typeof value === "object" &&
              value !== null &&
              Object.values(value).some((v) => v !== "")) ||
            (value !== null && value !== "")
        );
        this.page = 0;
        this.getContributorList();
      });
  }

  getContributorList() {
    this.filters = {
      ...this.filters,
      orgId: this.orgId,
      search: this.search,
    };
    if (this.orgDetail?.organizationName === "IndiaAI") {
      this.filters = {
        ...this.filters,
        orgName: "IndiaAI",
      };
    }
    this.isLoading = true;
    this.apiService
      .fetchContributorLeaderboard(this.page + 1, this.size, this.filters)
      .pipe(
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe({
        next: (res) => {
          const data =
            res.data?.map((item: any) => ({
              ...item,
            })) || [];
          this.tableData = data;
          this.total = res.total;
        },
        error: (err) => {
          console.error(err);
        },
      });
  }

  exportAsExcel() {
    this.apiService.exportContributorLeaderboardList(this.filters).subscribe({
      next: (res: any) => {
        this.utilityService.downloadBlob(
          res,
          `organization_${this.orgDetail.name}_members_leaderboard.xlsx`
        );
      },
      error: (err) => {
        console.error(err);
      },
    });
  }
}
